import React from 'react';
import HtmlContent from '../common/HtmlContent';

/**
 * Notes Component
 * 
 * Displays user notes in the exact same format as the legacy HTML site.
 * This preserves the visual structure from the original site.
 */
const Notes = ({ notes }) => {
  if (!notes) return null;

  return (
    <div className="tool-notes">
      <h3>Notes</h3>
      <div className="notes-content">
        {typeof notes === 'string' ? (
          <HtmlContent html={notes} className="notes-html" containerClass="" />
        ) : (
          <p>{notes}</p>
        )}
      </div>
    </div>
  );
};

export default Notes; 